import React, { useState } from 'react';
import { Layout, Typography, Card, Row, Col, Button, Tabs } from 'antd';
import { FaHandshake } from 'react-icons/fa';

const { Content } = Layout;
const { Title, Paragraph } = Typography;
const { TabPane } = Tabs;

const vendors = {
    "Cloud & AI Infrastructure": [
        { name: "AWS", description: "Cloud computing and AI/ML services.", website: "https://aws.amazon.com" },
        { name: "Google Cloud", description: "AI and machine learning cloud solutions.", website: "https://cloud.google.com" }
    ],
    "EdTech & Learning": [
        { name: "Coursera", description: "Online AI & ML courses from top universities.", website: "https://coursera.org" },
        { name: "Udacity", description: "AI nanodegree programs and training.", website: "https://udacity.com" }
    ],
    "Tech Hardware & Software": [
        { name: "NVIDIA", description: "AI GPUs and deep learning hardware.", website: "https://nvidia.com" },
        { name: "Intel AI", description: "AI processors and optimization tools.", website: "https://intel.com" }
    ],
    "Hiring & Recruitment": [
        { name: "LinkedIn", description: "AI job and internship opportunities.", website: "https://linkedin.com" },
        { name: "Turing", description: "Remote AI developer hiring.", website: "https://turing.com" }
    ],
    "Cybersecurity & Compliance": [
        { name: "IBM Security", description: "Cybersecurity solutions and AI-driven threat detection.", website: "https://ibm.com/security" },
        { name: "Palo Alto Networks", description: "Next-gen cybersecurity solutions.", website: "https://paloaltonetworks.com" }
    ]
};

function VendorPartnerships() {
    const [currentTab, setCurrentTab] = useState("Cloud & AI Infrastructure");

    return (
        <Layout>
            <Content style={{ padding: '60px', background: '#f0f2f5', minHeight: '100vh' }}>
                <Title level={2} style={{ fontSize: '20px', color: '#333', display: 'flex', alignItems: 'center', marginBottom: '28px' }}>
                    <FaHandshake style={{ marginRight: '14px', fontSize: '20px', color: '#1890ff' }} /> Vendor Partnerships
                </Title>
                <Paragraph style={{ fontSize: '16px', color: '#666', marginBottom: '48px', maxWidth: '800px', lineHeight: '1.6' }}>
                    JectHub collaborates with industry-leading vendors to provide AI students and professionals with cutting-edge tools, learning resources, and career opportunities. Explore our vendor partners below.
                </Paragraph>

                <Tabs
                    defaultActiveKey="Cloud & AI Infrastructure"
                    onChange={setCurrentTab}
                    tabBarStyle={{ fontWeight: '700', color: '#1890ff', borderBottom: '3px solid #1890ff' }}
                >
                    {Object.keys(vendors).map(category => (
                        <TabPane tab={<strong>{category}</strong>} key={category}>
                            <Row gutter={[24, 24]}>
                                {vendors[category].map((vendor, index) => (
                                    <Col xs={24} sm={12} md={8} lg={4} key={index}>
                                        <Card
                                            hoverable
                                            style={{
                                                borderRadius: '12px',
                                                overflow: 'hidden',
                                                boxShadow: '0 8px 16px rgba(0,0,0,0.15)',
                                                background: '#fff',
                                                padding: '24px',
                                                height: '260px',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'space-between',
                                                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.transform = 'translateY(-10px)';
                                                e.currentTarget.style.boxShadow = '0 12px 24px rgba(0,0,0,0.2)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.transform = 'translateY(0)';
                                                e.currentTarget.style.boxShadow = '0 8px  surrounds16px rgba(0,0,0,0.15)';
                                            }}
                                        >
                                            <div>
                                                <Title level={4} style={{ color: '#333', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
                                                    {vendor.name}
                                                </Title>
                                                <Paragraph style={{ color: '#666', fontSize: '14px', lineHeight: '1.5', marginBottom: '16px' }}>
                                                    {vendor.description}
                                                </Paragraph>
                                            </div>
                                            <Button
                                                type="primary"
                                                href={vendor.website}
                                                target="_blank"
                                                style={{
                                                    backgroundColor: '#1890ff',
                                                    borderColor: '#1890ff',
                                                    borderRadius: '8px',
                                                    fontWeight: 'bold',
                                                    height: '44px',
                                                    width: '100%',
                                                    transition: 'all 0.3s ease',
                                                    boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.target.style.backgroundColor = '#40a9ff';
                                                    e.target.style.boxShadow = '0 6px 12px rgba(0,0,0,0.3)';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.target.style.backgroundColor = '#1890ff';
                                                    e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
                                                }}
                                            >
                                                Visit Website
                                            </Button>
                                        </Card>
                                    </Col>
                                ))}
                            </Row>
                        </TabPane>
                    ))}
                </Tabs>

                {/* Custom CSS */}
                <style jsx global>{`
                    .ant-card {
                        animation: fadeIn 0.5s ease-in-out;
                    }
                    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
                        color: #1890ff !important;
                    }
                    .ant-tabs-ink-bar {
                        background: #1890ff !important;
                    }
                    @keyframes fadeIn {
                        0% { opacity: 0; transform: translateY(10px); }
                        100% { opacity: 1; transform: translateY(0); }
                    }
                `}</style>
            </Content>
        </Layout>
    );
}

export default VendorPartnerships;